<template>
  <div class="books-container">
    <div class="bootstrap-wrapper">
      <div class="container">
        <div class="row hidden-row"></div>
        <router-view />
        <div class="row">
          <FooterComponent />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FooterComponent from "@/components/Footer";

export default {
  name: "Resources",
  components: {
    FooterComponent,
  },
};
</script>
